import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { DisclaimerModal } from "@/components/landing/DisclaimerModal";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { NewsTicker } from "@/components/landing/NewsTicker";
import { Marquee } from "@/components/landing/Marquee";
import { About } from "@/components/landing/About";
import { Mission } from "@/components/landing/Mission";
import { WhatWeDo } from "@/components/landing/WhatWeDo";
import { Roadmap } from "@/components/landing/Roadmap";
import { NqmHub } from "@/components/landing/NqmHub";
import { NewsSection } from "@/components/landing/NewsSection";
import { LegalSection } from "@/components/landing/LegalSection";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#F8FAFC] text-slate-900 antialiased">
        <DisclaimerModal />
        <Header />
        <main>
          <Hero />
          <NewsTicker />
          <Marquee />
          <About />
          <Mission />
          <WhatWeDo />
          <Roadmap />
          <NqmHub />
          <NewsSection />
          <Contact />
          <LegalSection />
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
